export default function AboutHero() {
  const founders = [
    {
      name: 'Tara Vace',
      credentials: 'MSN, AGAC-NP',
      title: 'Co-Founder & Nurse Practitioner',
      image: 'https://public.readdy.ai/ai/img_res/8426cd214db1b3a387e3d78a3867f0c3.jpg',
      bio: 'Tara brings extensive experience in acute and critical care to every treatment at IV Hydration Club. As an Adult-Gerontology Acute Care Nurse Practitioner, her advanced clinical training ensures every client receives safe, evidence-based care with careful attention to health history, medications, and individual wellness goals.',
    },
    {
      name: 'Jasmine Vace',
      credentials: 'MSN, AGAC-NP',
      title: 'Co-Founder & Nurse Practitioner',
      image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20elegant%20confident%20female%20nurse%20practitioner%20in%20her%2030s%20wearing%20refined%20neutral%20tones%20warm%20studio%20lighting%20calm%20assured%20expression%20premium%20wellness%20clinic%20environment%20high%20end%20medical%20professional%20photography%20soft%20bokeh%20background&width=600&height=750&seq=jasmine_vace_founder_01&orientation=portrait',
      bio: 'Jasmine\'s background in acute and critical care settings brings a strong medical foundation to every infusion experience. As a co-founder and AGAC-NP, she is committed to delivering treatments that are not only effective but deeply personalized — ensuring your safety and comfort at every step.',
    },
  ];

  return (
    <section className="pt-32 pb-20 px-6 lg:px-12 bg-sand">
      <div className="max-w-7xl mx-auto">

        {/* Page Header */}
        <div className="text-center mb-16">
          <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-4">
            About Us
          </p>
          <h1 className="text-5xl md:text-6xl font-light text-charcoal tracking-tight mb-6">
            About Our Clinic
          </h1>
          <div className="w-16 h-px bg-gold mx-auto mb-8"></div>
          <p className="text-greige text-lg font-light leading-relaxed max-w-3xl mx-auto">
            IV Hydration Club is a medical wellness clinic providing intravenous hydration, vitamin therapy, and recovery treatments designed to help clients feel energized, restored, and performing at their best.
          </p>
        </div>

        {/* Clinic Info */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#e8e2da] mb-20 rounded-xl overflow-hidden">
          {[
            {
              icon: 'ri-shield-check-line',
              title: 'Medical-Grade Care',
              desc: 'All treatments are administered by licensed medical professionals using medical-grade ingredients in a safe, clinical environment.',
            },
            {
              icon: 'ri-heart-pulse-line',
              title: 'Clinically Formulated',
              desc: 'Each infusion is formulated to support hydration, immune health, recovery, and overall wellness — tailored to your individual goals.',
            },
            {
              icon: 'ri-user-heart-line',
              title: 'Professional Oversight',
              desc: 'We combine modern wellness therapies with professional medical oversight to deliver treatments that are efficient, restorative, and personalized.',
            },
          ].map((item, i) => (
            <div key={i} className="bg-sand px-10 py-10 text-center">
              <div className="w-12 h-12 mx-auto mb-5 flex items-center justify-center rounded-full bg-gold/10">
                <i className={`${item.icon} text-2xl text-gold`}></i>
              </div>
              <h3 className="text-sm font-normal tracking-widest uppercase text-charcoal mb-3">{item.title}</h3>
              <p className="text-greige text-sm font-light leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>

        {/* About Our Providers */}
        <div className="bg-bone rounded-2xl px-12 py-14 mb-20">
          <div className="max-w-3xl mx-auto text-center">
            <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-4">Our Providers</p>
            <h2 className="text-3xl md:text-4xl font-light text-charcoal mb-6 tracking-wide">About Our Providers</h2>
            <div className="w-12 h-px bg-gold mx-auto mb-8"></div>
            <div className="space-y-5 text-greige text-base font-light leading-relaxed">
              <p>
                All treatments at IV Hydration Club are overseen by licensed Nurse Practitioners and registered nurses with advanced clinical training.
              </p>
              <p>
                Our providers have extensive experience in acute and critical care settings and bring a strong medical foundation to every treatment we offer. This ensures every client receives safe, evidence-based care with careful attention to health history, medications, and individual wellness goals.
              </p>
              <p>
                Your safety and comfort remain our highest priority throughout every infusion experience.
              </p>
            </div>
          </div>
        </div>

        {/* Founders */}
        <div className="mb-6">
          <div className="text-center mb-12">
            <p className="text-[11px] font-light tracking-[0.35em] uppercase text-greige mb-4">The Founders</p>
            <h2 className="text-3xl md:text-4xl font-light text-charcoal tracking-wide">Meet the Sisters Behind the Club</h2>
            <div className="w-12 h-px bg-gold mx-auto mt-6"></div>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {founders.map((founder, index) => (
              <div key={index} className="bg-white rounded-2xl overflow-hidden flex flex-col md:flex-row group">
                <div className="w-full md:w-48 flex-shrink-0 h-64 md:h-auto overflow-hidden">
                  <img
                    src={founder.image}
                    alt={founder.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-8 flex flex-col justify-center">
                  <p className="text-[10px] font-light tracking-[0.3em] uppercase text-gold mb-2">{founder.title}</p>
                  <h3 className="text-2xl font-light text-charcoal mb-1 tracking-wide">{founder.name}</h3>
                  <p className="text-gold text-sm font-light tracking-wider mb-4">{founder.credentials}</p>
                  <p className="text-greige text-sm font-light leading-relaxed">{founder.bio}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}
